import { render, staticRenderFns } from "./frontAcercadeContainer.vue?vue&type=template&id=a6271a8c&scoped=true&"
import script from "./frontAcercadeContainer.vue?vue&type=script&lang=js&"
export * from "./frontAcercadeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6271a8c",
  null
  
)

export default component.exports